var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-app-window"},[_c('section',{staticClass:"custom-scroll user-chats scroll-area px-0 flex-grow-1 w-100 overflow-auto h-100",attrs:{"id":"chatScrollDiv"}},[_c('div',{staticClass:"chats"},[_c('div',{staticClass:"chat"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }